import React, { useState } from "react";
import "./ProfesionalesExcelencia.css";
import drGonzalo from "../assets/images/dr-gonzalo.png";
import drMichael from "../assets/images/dr-michael.png";
import logoUChile from "../assets/images/logo-uchile.png";
import logoUcam from "../assets/images/logo-ucam.png";
import { useNavigate } from "react-router-dom";
import DoctorGonzalo from "./DoctorGonzalo";
import ModalSimple from "./ModalSimple";
import DoctorMichael from "./DoctorMichael";

const ProfesionalCard = ({ profesional }) => {
  return (
    <div className="profesional-card">
      <div 
        className="profesional-imagen"
        style={{
          backgroundImage: `url(${profesional.imagen})`,
          backgroundPosition: 'top',
          backgroundSize: 'cover',
          height: '240px',
          width: '280px',
          borderRadius: '50%'
        }}
      />
      <div className="profesional-info">
        <h3>{profesional.nombre}</h3>
        <p>{profesional.especialidad}</p>
        <p>{profesional.descripcion}</p>
      </div>
    </div>
  );
};

const ProfesionalesExcelencia = () => {
  const navigate = useNavigate();
  const [showModalGonzalo, setShowModalGonzalo] = useState(false);
  const [showModalMichael, setShowModalMichael] = useState(false);

  const handleClick = (ruta) => {
    if (ruta === "/doctor-gonzalo") {
      setShowModalGonzalo(true);
    } else if (ruta === "/doctor-michael") {
      setShowModalMichael(true);
    } else {
      navigate(ruta);
    }
  };

  return (
    <div className="profesionales-page">
      {/* Sección de Certificado de Confianza */}
      <section className="certificado-confianza">
        <div className="container">
          <div className="certificado-content">
            <div className="certificado-imagen">
              <img src='/assets/images/doctor-trabajando.jpg' alt="Doctor trabajando" />
            </div>
            <div className="certificado-texto">
              <h2>CERTIFICADO DE CONFIANZA</h2>
              <p>
                Una sonrisa es mucho más que una expresión; es seguridad, es
                conexión, es calidad de vida. Sabemos lo que significa sentir
                que algo no encaja, que la comodidad al comer o la confianza al
                hablar se han visto afectadas. Con eso en mente, en CAIMA-Centro
                Avanzado de Implantologia Maxilofacial Antofagasta, no solo
                diseñamos tratamientos, sino experiencias transformadoras unidas
                a una pasión profunda por nuestro trabajo como Implantólogos.
              </p>
              <p>
                Con un enfoque cercano y tecnología de vanguardia en implantes
                dentales, trabajamos para que cada paciente recupere no solo su
                sonrisa, sino la tranquilidad de ser y sentirse plenamente ellos
                mismos.
              </p>

              <p>Ven a visitarnos y descubre la diferencia!</p>

              <button
                className="agendar-btn"
                onClick={() =>
                  window.open(
                    "https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1"
                  )
                }
              >
                AGENDA TU CITA
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Especialistas */}
      <section className="nuestros-especialistas">
        <div className="container">
          <h2>NUESTROS ESPECIALISTAS ACREDITADOS</h2>
          <div className="especialistas-grid">
            <div className="especialista-card">
              <img src={drGonzalo} alt="Dr. Gonzalo Varela" />
              <h3>Dr. Gonzalo Varela Alegre</h3>
              <button
                className="saber-mas-btn"
                onClick={() => handleClick("/doctor-gonzalo")}
              >
                Saber más
              </button>
            </div>
            <div style={{ marginTop: '110px' }}>
              <div>
                <img
                  src={logoUChile}
                  alt="Universidad de Chile"
                  className="logo-universidad"
                />
                <br />
                <img src={logoUcam} alt="UCAM" className="logo-universidad" />
              </div>
            </div>
            <div className="especialista-card">
              <img src={drMichael} alt="Dr. Michael Arancibia" />
              <h3>Dr. Michael Arancibia A.</h3>
              <button
                className="saber-mas-btn"
                onClick={() => handleClick("/doctor-michael")}
              >
                Saber más
              </button>
            </div>
          </div>
        </div>
      </section>

      <ModalSimple
        isOpen={showModalGonzalo}
        onClose={() => setShowModalGonzalo(false)}
      >
        <DoctorGonzalo />
      </ModalSimple>

      <ModalSimple
        isOpen={showModalMichael}
        onClose={() => setShowModalMichael(false)}
      >
        <DoctorMichael />
      </ModalSimple>
    </div>
  );
};

export default ProfesionalesExcelencia;
